import { SEARCH_HUB_CATALOGS } from "@apiUtils";
import { FilterBuilder, mutationFetch, type SearchPayload } from "@atlas/sdk";

export interface IHubCatalogSearchPage {
  items: unknown[];
  totalCount: number;
}

export function normalizeHubCatalogSearchPayload(
  payload: SearchPayload,
): SearchPayload {
  return {
    ...payload,
    filter:
      payload.filter instanceof FilterBuilder
        ? payload.filter.build()
        : payload.filter,
  };
}

export async function fetchHubCatalogSearchPage(
  payload: SearchPayload,
): Promise<IHubCatalogSearchPage> {
  const normalizedPayload = normalizeHubCatalogSearchPayload(payload);
  const response = await mutationFetch<{
    items?: unknown[];
    data?: unknown[];
    totalCount?: number;
    total?: number;
    count?: number;
  }>({
    url: SEARCH_HUB_CATALOGS,
    method: "POST",
    body: {
      ...normalizedPayload,
      startIndex: normalizedPayload.startIndex ?? 0,
    },
  });

  if (response == null) {
    throw new Error("Hub catalog search returned no data");
  }

  if (
    !Array.isArray(response.items) &&
    (Array.isArray(response.data) ||
      response.total !== undefined ||
      response.count !== undefined)
  ) {
    return {
      items: response.data ?? [],
      totalCount: response.total ?? response.count ?? 0,
    };
  }

  const items = Array.isArray(response.items)
    ? response.items
    : (response.data ?? []);

  return {
    items,
    totalCount:
      response.totalCount ?? response.total ?? response.count ?? items.length,
  };
}

export function getHubCatalogSearchQueryKey(payload: SearchPayload) {
  return [
    SEARCH_HUB_CATALOGS,
    normalizeHubCatalogSearchPayload(payload),
  ] as const;
}
